import {config, request} from '../utils'
import {stringify} from 'qs'

export default {
  getProducts() {
    return request(`/public/product`)
  },
  getProduct(productId) {
    return request(`/public/product/${productId}`)
  },
  getInventory(productId, travelDate) {
    return request(`${config.apiPrefix}/ticket/inventory?productId=${productId}&travelDate=${travelDate}`)
  },
  getFreeTicketCardType() {
    return request(`/public/free-ticket-card-type`)
  },
  submit(params) {
    return request(`${config.apiPrefix}/ticket/order`, {
      method: 'POST',
      body: params,
    })
  },
  query(params) {
    return request(`${config.apiPrefix}/ticket/order?${stringify(params)}`)
  },
  getTicketOrder(orderId) {
    return request(`${config.apiPrefix}/ticket/order/${orderId}`)
  },
}
